import { getAccessToken, getAuthHeaders, SessionError } from '../session/session';
import { ApiError } from './apiError';

const UNAUTHORIZED = 401;

/**
 * Garante um token válido e devolve os headers da sessão. A falha vira `ApiError` de origem
 * `session`; `report` recebe só as que tiveram resposta do servidor.
 */
export const authenticatedHeaders = async (operation: string | undefined, report: (error: ApiError) => void) => {
  try {
    await getAccessToken();
  } catch (cause) {
    const session = cause instanceof SessionError ? cause : undefined;
    const status = session?.status;
    const error = new ApiError({
      message: `Session error in operation ${operation} - ${(cause as Error).message}`,
      origin: 'session',
      status,
      code: session?.reason,
      operation,
      cause,
    });
    if (status !== undefined) report(error);
    // O CobliAxios recarrega a página quando a renovação leva 401, e o app volta para o login.
    if (status === UNAUTHORIZED) window.location.reload();
    throw error;
  }
  return getAuthHeaders();
};
